__turbopack_context__.v({
  "disclaimer": "-IPJ2G_disclaimer",
  "disclaimer__header": "-IPJ2G_disclaimer__header",
  "disclaimer__icon": "-IPJ2G_disclaimer__icon",
  "disclaimer__img": "-IPJ2G_disclaimer__img",
  "disclaimer__left": "-IPJ2G_disclaimer__left",
  "disclaimer__right": "-IPJ2G_disclaimer__right",
  "ref": "-IPJ2G_ref",
  "ref-wrapper": "-IPJ2G_ref-wrapper",
});
